import React, {useCallback} from "react";
import { ListEditor } from "../../components/list-editor";
import {
    SiteBuildContractor,
    useBuildContractorQueryQuery,
    BuildContractorQueryQuery,
    useUpdateSiteBuildContractorMutation, UpdateSiteBuildContractor
} from '../../generated/graphql';
import { FieldTableColumnProps } from 'components/FieldTable/FieldTableTypes';
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

function newRow():SiteBuildContractor {
    return {
        id: uniqueId(),
        label: ''
    }
}

const columns:FieldTableColumnProps<SiteBuildContractor>[] = [{
    header: 'Name',
    accessor: 'label',
    dataType:'text'
}];

function getValues(query:BuildContractorQueryQuery):SiteBuildContractor[] {
    // query.data or whatever is stored in the object
    return query?.siteBuildContractors;
}

export const SiteBuildContractors = () => {
    const url = useLocation().pathname;
    const query = useBuildContractorQueryQuery();
    //let mutation: (options?: MutationFunctionOptions<UpdateSiteBuildContractorMutation, UpdateSiteBuildContractorMutationVariables, DefaultContext, ApolloCache<any>>) => Promise<FetchResult<UpdateSiteBuildContractorMutation>>;
    const [mutation,mutationResult] = useUpdateSiteBuildContractorMutation();
    return (
        <ListEditor
            mutation={mutation}
            columns={columns}
            title="Site Build Contractors"
            getValues={getValues}
            query={query}
            newRow={newRow}
            permission="sites"
            newRowLabel="Add Site Build Contractor"
             baseUrl={url}
            relationships={null}
            className="site-build-contractors"
            saveResult={mutationResult}
        />);
}
